export default __webpack_public_path__ + "static/acceleratedLearning-5b080e4c737196bc3db7bca133694c32.png";